//
//
//
//


export default {
  props: {
    nvBarData: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      xData: [],
      data1: [],
      data2: [],
      data3: [],
      barChart: null, // 图表实例
      img: []
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.barChart?.resize()
    },
    nvBarData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.barChart?.clear() // 清空当前实例
    this.barChart?.dispose() // 销毁图表
    this.barChart = null
  },
  methods: {

    getData () {
      this.xData = []
      this.data1 = []
      this.data2 = []
      this.data3 = []
      this.nvBarData?.forEach((item) => {
        // console.log(item.brokerIcon)
        this.img.push(item.brokerIcon ? item.brokerIcon : 'https://resources.interface003.com/web20/img/default/20-20.png')
        this.xData.push(item.brokerName)
        this.data1.push({
          name: item.brokerName,
          value: item.cashIn // 净流入
        })
        this.data2.push({
          name: item.brokerName,
          value: item.Deposite // 流出
        })

        this.data3.push({
          name: item.brokerName,
          value: item.Withdraw
        })
      })
      this.getBarCharts()
    },
    getBarCharts () {
      if (!this.barChart) this.barChart = this.$echarts.init(document.getElementsByClassName('fundsFlow-nvbar-charts')[0])
      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          axisPointer: {
            type: 'none'
          },
          padding: [8, 12],
          borderWidth: 0,
          borderRadius: 4,
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item">${params[0].name}</div>
             <div class="item"><span class="dot" style="background-color:${params[0].color.colorStops[0].color}"></span><span>${this.$t('28684')}: ${this.num2CurrencyNo(params[0].value)}</span></div>
             <div class="item"><span class="dot" style="background-color:${params[1].color.colorStops[0].color}"></span><span>${this.$t('28661')}: ${this.num2CurrencyNo(params[1].value)}</span></div>
             <div class="item"><span class="dot" style="background-color:${params[2].color.colorStops[0].color}"></span><span>${this.$t('28662')}: ${this.num2CurrencyNo(Math.abs(params[2].value))}</span></div>
            </div>`
          }
        },
        legend: {
          itemWidth: 10,
          itemHeight: 2,
          textStyle: {
            fontSize: 12,
            color: '#3D3D3D'
          },
          data: [this.$t('28684'), this.$t('28661'), this.$t('28662')]
        },
        grid: {
          top: '10%',
          bottom: '0px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(41, 41, 41, 1)'
              }
            },
            axisLabel: {
              formatter: (value) => {
                // return value
                if (value === 0) {
                  return 0
                } else {
                  return this.formatDecimal(Math.abs(value / 1000000), 0) + 'm'
                }
              }
            },
            // splitNumber: 2,
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        yAxis: [
          {
            z: 9,
            type: 'category',

            show: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(41, 41, 41, 1)'
              }
            },
            axisLabel: {
              show: false
            },
            data: this.xData
          }
        ],
        series: [
          {
            name: this.$t('28684'),
            type: 'bar',
            barGap: '50%',
            emphasis: {
              show: true
              // textStyle: {
              //   color: '#000'
              // }
            },
            label: {
              show: true,
              color: 'rgba(61, 61, 61, 1)',
              fontSize: 12,
              position: 'left',
              // series数据label前添加定制图标
              formatter (param) {
                const res = '\t' + param.name + ' {img' + param.dataIndex + '|}'
                return res
              },
              rich: {

                img0: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[0]
                  }
                },
                img1: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[1]
                  }
                },
                img2: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[2]
                  }
                },
                img3: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[3]
                  }
                },
                img4: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[4]
                  }
                },
                img5: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[5]
                  }
                },
                img6: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[6]
                  }
                },
                img7: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[7]
                  }
                },
                img8: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[8]
                  }
                },
                img9: {
                  height: 14,
                  width: 14,
                  align: 'right',
                  backgroundColor: {
                    image: this.img[9]
                  }
                }
              }

            },
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: 'rgba(236, 143, 37, 1)'
              },
              {
                offset: 1,
                color: 'rgba(255, 176, 87, 1)'
              }

            ]),

            data: this.data1
          },
          {
            name: this.$t('28661'),
            type: 'bar',
            stack: 'Total',
            label: {
              show: false
            },
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: 'rgba(31, 153, 112, 1)'
              },
              {
                offset: 1,
                color: 'rgba(54, 178, 137, 1)'
              }

            ]),

            data: this.data2
          },
          {
            name: this.$t('28662'),
            type: 'bar',
            stack: 'Total',
            label: {
              show: false,
              position: 'left'
            },
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 1,
                color: 'rgba(204, 41, 68, 1)'
              },
              {
                offset: 0,
                color: 'rgba(229, 92, 115, 1)'
              }

            ]),
            // emphasis: {
            //   focus: 'series'
            // },
            data: this.data3
          }
        ]
      }
      this.barChart?.clear()
      this.barChart?.setOption(option, true)
    }
  }
}
